// extracted by mini-css-extract-plugin
export default {"price":"M7-z","priceRow":"N7-z","onSale":"O7-z","msrpLabelPrice":"P7-z","msrpLabel":"Q7-z","originalPrice":"R7-z","percentOff":"S7-z"};